import { gql } from 'apollo-boost';

export const GET_INSTALLATION_TOKEN = gql`
  query GetInstallationToken {
    getInstallationToken {
      token
    }
  }
`;
